import store from '@/state/store'

export default [

  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: false,
    },
    component: () => {

      return import('./views/dashboards/default')

      // var userRole = ('; '+document.cookie).split(`; userr=`).pop().split(';')[0];
      
      
      // if (!userRole || userRole == 0) {
      //   return import('./views/dashboards/default');
      // } else  if (userRole == 1) {
      //   return import('./views/reporting/reporting')
      // }
      
      
      
      // else if (userRole == 1) {
      //   /*return import('./views/reporting/supplier-reporting');*/ return import('./views/dashboards/default');
      // }else if(userRole == 2){
      //   /*return import('./views/dashboards/admin');*/ return import('./views/dashboards/default');
      // }

      
    }
  },


  {
    path: '/zone',
    name: 'zone',
    meta: { authRequired: true },
    component: () => import('./views/zone/zone')
  },

  {
    path: '/partenaire',
    name: 'partenaire',
    meta: { authRequired: true },
    props(route) {
      return {partnerId: (Number) (route.query.partnerId) }
    },
    component: () => import('./views/partner/partner')
  },

  {
    path: '/customer-info',
    name: 'customer-info',
    meta: { authRequired: true },
    props(route) {
      return {customerId: (Number) (route.query.customerId) }
    },
    component: () => import('./views/admin/customer-info')
  },

  {
    path: '/profil',
    name: 'Gestion de Profile',
    meta: { authRequired: true },
    component: () => import('./views/account/profil')
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/')
        )

        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },




  // {
  //   path: '/banners',
  //   name: 'Admin Banners',
  //   meta: { authRequired: true },
  //   component: () => import('./views/admin/banners')
  // },

  {
    path: '/bannieres',
    name: 'Bannières',
    meta: { authRequired: true },
    component: () => import('./views/banner-news/banners-news')
  },

  {
    path: '/utilisateurs',
    name: 'liste des utilisateurs',
    meta: { authRequired: true },
    component: () => import('./views/admin/listOfUsers')
  },
  {
    path: '/customer-utilisateurs',
    name: 'liste-des-utilisateurs',
    meta: { authRequired: true },
    props(route) {
      return {customerId: (Number) (route.query.id) }
    },
    component: () => import('./views/customer-admin/customerAdmin')
  },

  {
    path: '/campaign',
    name: 'campagne',
    meta: { authRequired: true },
    component: () => import('./views/campaign/campaign')
  },
  {
    path: '/campaign/planification',
    name: 'delivery-planification',
    meta: { authRequired: true },
    props(route) {
      return {campaignId: (Number) (route.query.campaignId) }
    },
    component: () => import('./views/campaign/delivery-planification')
  },
  {
    path: '/campaign/etat',
    name: 'delivery-etat',
    meta: { authRequired: true },
    props(route) {
      return {campaignId: (Number) (route.query.campaignId) }
    },
    component: () => import('./views/campaign/delivery-etat')
  },
  {
    path: '/campaign/details',
    name: 'details-campagne',
    meta: { authRequired: true },
    props(route) {
      return {campaignId: (Number) (route.query.campaignId) }
    },
    component: () => import('./views/campaign/campaign-component')
  },


  {
    path: '/reporting',
    name: 'Rapports & Stats',
    meta: { authRequired: true },
    component: () => import('./views/reporting/reporting')
  },

  {
    path: '/analytics',
    name: 'Rapports',
    meta: { authRequired: true },
    component: () => import('./views/reporting/reporting-customer')
  },

  
  {
    path: '/devis',
    name: 'Offre PubAg',
    meta: { authRequired: false },
    component: () => import('./views/request-quote/plane-proposal')
  },

  {
    path: '/demande/devis/:planeTitle',
    name: 'Demande Devis ',
    meta: { authRequired: false },
    component: () => import('./views/request-quote/request-quote')
  },
  {
    path: '/demande/devis/',
    name: 'Demandes Devis',
    meta: { authRequired: true },
    component: () => import('./views/request-quote/supplier/request-quote')
  },

  {
    path: '/nos-partenaires',
    name: 'Nos Partenaires',
    meta: { authRequired: false },
    component: () => import('./views/partner/our-partners')
  },

  {
    path: '/devenir-partenaire',
    name: 'Devenir un partenaire',
    meta: { authRequired: false },
    component: () => import('./views/partner/become-partner')
  },

  {
    path: '/contacter-nous',
    name: 'contacter-nous',
    meta: { authRequired: false },
    component: () => import('./views/contact-us/contact-us')
  },
  {
    path: '/concept-sacs-publicitaires',
    name: 'concept',
    meta: { authRequired: false },
    component: () => import('./views/concept/concept')
  },

  {
    path: '/atouts-sacs-publicitaires',
    name: 'atouts',
    meta: { authRequired: false },
    component: () => import('./views/atouts/atouts')
  },

    {
    path: '/qrmenu/:code',
    name: 'Qr Code Menu ',
    meta: { authRequired: false },
    component: () => import('./views/menu/menu'),
      props: route => ({
        tid: Number(route.query.tid),
        ts: String(route.query.ts),
      })
  },

  {
    path: '/qrtables',
    name: 'QrMenuTables',
    meta: { authRequired: true },
    component: () => import('./views/menu/order/qrtables.vue'),
    props: route => ({
      menuId: Number(route.query.menuId),
      start: Number(route.query.start),
      end: Number(route.query.end)
    })
  },

  {
    path: '/menu-order/:code',
    name: 'MenuOrder',
    meta: { authRequired: true },
    component: () => import('./views/menu/order/orders.vue'),
  }

]
